module.exports = __webpack_public_path__ + "assets/img/icon_bzgxz.3d4b0499.png";